import { date, InferType, object, ObjectSchema, string } from "yup";
import { CancelarOrcamentoContract } from "../contracts/cancelar-orcamento.contract";

export const cancelarOrcamentoSchema: ObjectSchema<CancelarOrcamentoContract> = object({

    cancellationDate: date().required("Data de cancelamento é obrigatória"),
    cancellationReason: string().required("Motivo de cancelamento é obrigatório"),
});


export type CancelarOrcamentoFormData = InferType<typeof cancelarOrcamentoSchema>;